import { ListItem, ListItemAvatar, ListItemText } from '@material-ui/core';
import AssetAvatar from '../card-navigation/AssetAvatar';

const AssetItem = ({ asset }) => (
    <ListItem divider>
        <ListItemAvatar>
            <AssetAvatar asset={asset} />
        </ListItemAvatar>
        <ListItemText primary={asset.name} secondary={asset.tagNumber || '-'} />
    </ListItem>
);

export default AssetItem;
